import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app, { createReducer } from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCart from './Components/MiniCart';
import QuickSearch from './Components/QuickSearch';
import Navigation from './Components/Navigation';
import FacetedSearch from './Components/FacetedSearch';
import FacetedSearchCompactContainer from './Components/FacetedSearchCompactContainer';
import DynamicComponent from './Components/DynamicComponent';
import DealerLocationContainer from './Components/DealerLocationContainer';
import MultipleSlider from './Components/NewsSlider/NewsBlockSlider';
import ProductsViewModelContainer from './Components/ProductsView/ProductsViewModelContainer';
import InventoryEditContainer from './Components/InventoryEdit/InventoryEditContainer';
import ChassiSearchContainer from './Components/ChassiSearch/ChassiSearchContainer';
import MarketingMaterial from './Components/MarketingMaterial';
import ShoppingListMenuButton from './Components/ShoppingListMenuButton';
import ShoppingListPage from './Pages/ShoppingListPage';
import ProductTierPriceContainer from './Components/ProductsView/ProductTierPriceContainer';
import SelectOrganizationForm from './Components/SelectOrganizationForm';
import CampaignContactUsBlock from './Components/CampaignContactUsBlock';
import SparePartsContainer from './Components/SparePartsContainer';
import { get } from './Services/http';
import constants from './constants';
import ClickCollectContainer from './Components/ClickCollectContainer';
import ProductBlockSlider from './Components/ProductBlockSlider';


window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
const store = createStore(
  app,
  preloadState,
  composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
);

// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
  if (!store.asyncReducers[key]) {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
  }
};

window.__litium = {
  ...window.__litium,
  bootstrapComponents: () => {
    // bootstrap React components, in case the HTML response we receive from the server
    // has React components. ReactDOM.render performs only an update on previous rendered
    // components and only mutate the DOM as necessary to reflect latest React element.
    bootstrapComponents();
  },
  cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
  registeredContainers.push(container);
  ReactDOM.render(element, container, callback);
};

let refreshLoginInterval;

if (
  window.__litium.constants.loggedIn &&
  window.__litium.constants.businessCustomer
) {
  refreshLoginInterval = setInterval(() => {
    get('/api/login/refreshSignIn').then();
  }, 60 * 60 * 1000);
}

window.onunload = () => {
  if (refreshLoginInterval) {
    clearInterval(refreshLoginInterval);
  }
  // make sure components are unmounted, redux's listener are unsubscribed
  // to fix issue with iframe navigation in IE
  registeredContainers.forEach((container) => {
    ReactDOM.unmountComponentAtNode(container);
  });
};

const containerClick = (element) => {
  const isTextSelected = window.getSelection().toString();
  if (!isTextSelected) {
    const link = element.querySelector('a');
    if (link) {
      link.click();
    }
  }
};

const bootstrapComponents = () => {
  if (document.querySelectorAll('product-view-model').length > 0) {
    Array.from(document.querySelectorAll('product-view-model')).forEach(
      (product) => {
        const productData = product.dataset;
        const useSlider = String(productData.useslider).toLowerCase() === 'true';
        const products = productData.products;
        const heading = productData.heading;
        const showAllProductInList = String(productData.showallproductinlist).toLowerCase() === 'true';
        const useToggle = String(productData.usetoggle).toLowerCase() === 'true';

        renderReact(
          <Provider store={store}>
            {useSlider ? (
              <ProductBlockSlider
                heading={heading}
                products={products}
                authenticated={constants.loggedIn}
                hidedescription={
                  productData.hidedescription?.toLowerCase() === 'true'
                }
                isClickAndCollect={constants.isClickAndCollect}
                disableSchemaMarkup={
                  String(productData.disableSchemaMarkup).toLocaleLowerCase() ===
                  'true'
                }
              />
            ) : (
              <ProductsViewModelContainer
                viewstate={0}
                heading={heading}
                products={products}
                isSpareParts={
                  String(productData.isspareparts).toLocaleLowerCase() === 'true'
                }
                disableSchemaMarkup={
                  String(productData.disableSchemaMarkup).toLocaleLowerCase() ===
                  'true'
                }
                isB2C={constants.isB2C}
                isClickAndCollect={constants.isClickAndCollect}
                authenticated={constants.loggedIn}
                hidedescription={
                  productData.hidedescription?.toLowerCase() === 'true'
                }
                useToggle={useToggle}
                showAllProductInList={showAllProductInList}
              />
            )}
          </Provider>,
          product
        );
      }
    );
  }

  if (document.querySelectorAll('product-tier-view-model').length > 0) {
    Array.from(document.querySelectorAll('product-tier-view-model')).forEach(
      (product) => {
        var productsData = product.dataset;
        renderReact(
          <Provider store={store}>
            <ProductTierPriceContainer product={productsData.product} />
          </Provider>,
          product
        );
      }
    );
  }

  if (document.querySelectorAll('[data-clickable]').length > 0) {
    Array.from(document.querySelectorAll('[data-clickable]')).forEach(
      (clickable) => {
        clickable.addEventListener('click', () => {
          containerClick(clickable);
        });
      }
    );
  }

  if (document.querySelectorAll('table:not(.defaulttable)').length > 0) {
    Array.from(document.querySelectorAll('table:not(.defaulttable)')).forEach(
      (tableitem) => {
        let divTable = document.createElement('div');
        divTable.className = 'tablediv';
        divTable.innerHTML = tableitem.outerHTML;
        tableitem.parentElement.replaceChild(divTable, tableitem);
      }
    );
  }

  if (document.querySelectorAll('product-item-listing').length > 0) {
    Array.from(document.querySelectorAll('product-item-listing')).forEach(
      (product) => {
        var items = JSON.parse(product.dataset.products);
        //   ReactDOM.render(
        //     <Provider store={store}>
        //       <ProductItemListingContainer {...{ items }} />
        //     </Provider>,
        //     product
        //   );
      }
    );
  }
  if (document.querySelectorAll('pricecalculator').length > 0) {
    const Pricecalculator = DynamicComponent({
      loader: () => import('./Components/pricecalculator'),
    });
    Array.from(document.querySelectorAll('pricecalculator')).forEach(
      (price) => {
        ReactDOM.render(
          <Provider store={store}>
            <Pricecalculator
              isauthorized={
                price.dataset.isauthorized?.toLowerCase() === 'true'
              }
              netpricincludingvat={price.dataset.netpricincludingvat}
              netpriceexcludingvat={price.dataset.netpriceexcludingvat}
              recommendedpriceexcludingvat={price.dataset.recommendedprice}
              recommendedpriceincludingvat={
                price.dataset.recommendedpriceincludingvat
              }
              campaignprice={price.dataset.campaignprice}
              campaignpriceincludingvat={
                price.dataset.campaignpriceincludingvat
              }
            />
          </Provider>,
          price
        );
      }
    );
  }
  if (document.querySelectorAll('vat-heading').length > 0) {
    const VATHeading = DynamicComponent({
      loader: () => import('./Components/VATHeading'),
    });
    Array.from(document.querySelectorAll('vat-heading')).forEach((data) => {
      ReactDOM.render(
        <Provider store={store}>
          <VATHeading />
        </Provider>,
        data
      );
    });
  }
  if (document.querySelectorAll('recommended-price-toggle').length > 0) {
    const RecommendedPricHeading = DynamicComponent({
      loader: () => import('./Components/RecommendedPriceToggle'),
    });
    Array.from(document.querySelectorAll('recommended-price-toggle')).forEach(
      (data) => {
        ReactDOM.render(
          <Provider store={store}>
            <RecommendedPricHeading />
          </Provider>,
          data
        );
      }
    );
  }

  if (document.querySelectorAll('save-cart').length > 0) {
    const SaveCartView = DynamicComponent({
      loader: () => import('./Components/SaveCartView'),
    });
    Array.from(document.querySelectorAll('save-cart')).forEach((data) => {
      ReactDOM.render(
        <Provider store={store}>
          <SaveCartView />
        </Provider>,
        data
      );
    });
  }
  if (document.querySelectorAll('.newsslider').length > 0) {
    // const Slider = DynamicComponent({
    //   loader: () => import("./Components/NewsSlider/NewsBlockSlider"),
    // });
    Array.from(document.querySelectorAll('.newsslider')).forEach(
      (slider, index) => {
        const { itemstodisplay, urlredirect } = slider.dataset;
        const values = [...slider.querySelectorAll('.newsslider__block')].map(
          (block) => {
            return {
              image: block.dataset.image,
              url: block.dataset.url,
              text: block.dataset.text,
              desc: block.dataset.desc,
            };
          }
        );
        if (values.length > 0) {
          ReactDOM.render(
            <Provider store={store}>
              <MultipleSlider
                values={values}
                itemstodisplay={itemstodisplay}
                urlredirect={urlredirect}
              />
            </Provider>,
            slider
          );
          // ReactDOM.render(<Slider values={values} itemstodisplay={itemstodisplay} urlredirect={urlredirect} />, slider);
        }
      }
    );
  }
  if (document.getElementById('miniCart')) {
    renderReact(
      <Provider store={store}>
        <MiniCart />
      </Provider>,
      document.getElementById('miniCart')
    );
  }
  if (document.getElementById('marketing-material')) {
    const el = document.getElementById('marketing-material');
    renderReact(
      <Provider store={store}>
        <MarketingMaterial {...el.dataset} />
      </Provider>,
      el
    );
  }
  if (document.querySelectorAll('chassi-search').length > 0) {
    Array.from(document.querySelectorAll('chassi-search')).forEach(
      (chassisearch) => {
        ReactDOM.render(
          <Provider store={store}>
            {/* <DealerLocationContainer {...{ items }} /> */}
            <ChassiSearchContainer></ChassiSearchContainer>
          </Provider>,
          chassisearch
        );
      }
    );
  }

  if (document.getElementById('chassi-sparepart-tag')) {
    const el = document.getElementById('chassi-sparepart-tag');
    renderReact(
      <Provider store={store}>
        <SparePartsContainer
          articleId={el.dataset.articlenumber}
        ></SparePartsContainer>
      </Provider>,
      el
    );
  }

  if (document.getElementById('click-collect-tag')) {
    const el = document.getElementById('click-collect-tag');
    renderReact(
      <Provider store={store}>
        <ClickCollectContainer
          productId={el.dataset.articlenumber}
          isInStock={el.dataset.isinstock}
        ></ClickCollectContainer>
      </Provider>,
      el
    );
  }

  if (document.getElementById('quickSearch')) {
    renderReact(
      <Provider store={store}>
        <QuickSearch />
      </Provider>,
      document.getElementById('quickSearch')
    );
  }
  if (document.getElementById('navbar')) {
    renderReact(
      <Provider store={store}>
        <Navigation />
      </Provider>,
      document.getElementById('navbar')
    );
  }
  if (document.querySelectorAll('.facetedSearch').length > 0) {
    document.querySelectorAll('.facetedSearch').forEach((el) => {
      const isSlider = el.dataset.isSlider;
      ReactDOM.render(
        <Provider store={store}>
          <FacetedSearch isSlider={isSlider} />
        </Provider>,
        el
      );
    });
  }

  if (document.getElementById('facetedSearchCompact')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById('facetedSearchCompact')
    );
  }
  if (document.getElementById('myPagePersons')) {
    const PersonList = DynamicComponent({
      loader: () => import('./Components/PersonListContainer'),
    });
    renderReact(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById('myPagePersons')
    );
  }
  if (document.getElementById('myPageAddresses')) {
    const AddressList = DynamicComponent({
      loader: () => import('./Components/AddressListContainer'),
    });
    renderReact(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById('myPageAddresses')
    );
  }
  if (document.getElementById('checkout')) {
    const Checkout = DynamicComponent({
      loader: () => import('./Components/Checkout'),
    });
    renderReact(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById('checkout')
    );
  }
  if (document.getElementById('lightBoxImages')) {
    const LightboxImages = DynamicComponent({
      loader: () => import('./Components/LightboxImages'),
    });
    import('./Reducers/LightboxImages.reducer').then(({ lightboxImages }) => {
      store.injectReducer('lightboxImages', lightboxImages);
      const rootElement = document.getElementById('lightBoxImages');
      const images = Array.from(rootElement.querySelectorAll('template'))
        .map()
        .map((img) => ({
          html: img.innerHTML,
          src: img.dataset.src,
        }));
      renderReact(
        <Provider store={store}>
          <LightboxImages images={images} />
        </Provider>,
        document.getElementById('lightBoxImages')
      );
    });
  }
  if (document.querySelectorAll('dealer-location').length > 0) {
    Array.from(document.querySelectorAll('dealer-location')).forEach(
      (dealer) => {
        ReactDOM.render(
          <Provider store={store}>
            {/* <DealerLocationContainer {...{ items }} /> */}
            <DealerLocationContainer
              restrictedcountry={dealer.dataset.restrictedcountry}
              isClickAndCollect={dealer.dataset.isclickncollect}
            />
          </Provider>,
          dealer
        );
      }
    );
  }
  if (document.getElementById('miniCart')) {
    renderReact(
      <Provider store={store}>
        <MiniCart />
      </Provider>,
      document.getElementById('miniCart')
    );
  }

  if (document.getElementById('quickSearch')) {
    renderReact(
      <Provider store={store}>
        <QuickSearch />
      </Provider>,
      document.getElementById('quickSearch')
    );
  }
  loadComponentIntoElement('shoppingList', ShoppingListMenuButton);
  loadComponentIntoElement('shoppingList-page', ShoppingListPage);
  loadComponentIntoElement('select-organization-form', SelectOrganizationForm);
  loadComponentIntoElement('campaign-contact-us-block', CampaignContactUsBlock);

  if (document.getElementById('navbar')) {
    renderReact(
      <Provider store={store}>
        <Navigation />
      </Provider>,
      document.getElementById('navbar')
    );
  }
  if (document.querySelectorAll('.facetedSearch').length > 0) {
    document.querySelectorAll('.facetedSearch').forEach((el) => {
      const isSlider = el.dataset.isSlider;
      ReactDOM.render(
        <Provider store={store}>
          <FacetedSearch isSlider={isSlider} />
        </Provider>,
        el
      );
    });
  }
  if (document.getElementById('facetedSearchCompact')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById('facetedSearchCompact')
    );
  }
  if (document.getElementById('myPagePersons')) {
    const PersonList = DynamicComponent({
      loader: () => import('./Components/PersonListContainer'),
    });
    renderReact(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById('myPagePersons')
    );
  }

  if (document.querySelectorAll('.shoppinglist-button-component').length > 0) {
    const ShoppingListButton = DynamicComponent({
      loader: () => import('./Components/ShoppingListButton'),
    });
    Array.from(
      document.querySelectorAll('.shoppinglist-button-component')
    ).forEach((element) => {
      let props = {
        isSticky: element.dataset.isSticky.toLowerCase() === 'true',
        isSmall: element.dataset.isSmall.toLowerCase() === 'true',
        productId: element.dataset.productId,
        product: element.dataset.product,
      };
      renderReact(
        <Provider store={store}>
          <ShoppingListButton {...props} />
        </Provider>,
        element
      );
    });
  }
  if (document.getElementById('myPageAddresses')) {
    const AddressList = DynamicComponent({
      loader: () => import('./Components/AddressListContainer'),
    });
    renderReact(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById('myPageAddresses')
    );
  }
  if (document.getElementById('checkout')) {
    const Checkout = DynamicComponent({
      loader: () => import('./Components/Checkout'),
    });
    renderReact(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById('checkout')
    );
  }
  if (document.getElementById('lightBoxImages')) {
    const LightboxImages = DynamicComponent({
      loader: () => import('./Components/LightboxImages'),
    });
    import('./Reducers/LightboxImages.reducer').then(({ lightboxImages }) => {
      store.injectReducer('lightboxImages', lightboxImages);
      const rootElement = document.getElementById('lightBoxImages');
      const images = Array.from(rootElement.querySelectorAll('a')).map(
        (img) => ({
          src: img.dataset.src,
        })
      );
      const thumbnails = Array.from(
        rootElement.querySelectorAll('a img')
      ).map((img) => ({ src: img.src }));
      renderReact(
        <Provider store={store}>
          <LightboxImages images={images} thumbnails={thumbnails} />
        </Provider>,
        document.getElementById('lightBoxImages')
      );
    });
  }

  if (document.querySelectorAll('.slider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/Slider'),
    });
    Array.from(document.querySelectorAll('.slider')).forEach(
      (slider, index) => {
        const values = [...slider.querySelectorAll('.slider__block')].map(
          (block) => {
            return {
              image: block.dataset.image,
              url: block.dataset.url,
              text: block.dataset.text,
              content: block.dataset.content,
              actionText: block.dataset.actionText,
            };
          }
        );
        if (values.length > 0) {
          renderReact(<Slider values={values} />, slider);
        }
      }
    );
  }

  if (document.querySelectorAll('.productandcategory__slider').length > 0) {
    const ProductAndCategorySlider = DynamicComponent({
      loader: () => import('./Components/ProductAndCategorySlider'),
    });
    Array.from(
      document.querySelectorAll('.productandcategory__slider')
    ).forEach((slider, index) => {
      const values = [
        ...slider.querySelectorAll('.product-and-category__block'),
      ].map((block) => {
        return {
          image: block.dataset.image,
          url: block.dataset.url,
          text: block.dataset.text,
        };
      });
      if (values.length > 0) {
        let responsive = {};
        if (values.length > 6) {
          responsive = {
            desktop: {
              breakpoint: { max: 10000, min: 1024 },
              items: 6,
            },
            tablet: {
              breakpoint: { max: 1024, min: 464 },
              items: 3,
            },
            mobile: {
              breakpoint: { max: 640, min: 0 },
              items: 1,
            },
          };
        }
        if (values.length >= 5) {
          responsive = {
            desktop: {
              breakpoint: { max: 10000, min: 1024 },
              items: 5,
            },
            tablet: {
              breakpoint: { max: 1024, min: 464 },
              items: 3,
            },
            mobile: {
              breakpoint: { max: 640, min: 0 },
              items: 1,
            },
          };
        } else {
          responsive = {
            desktop: {
              breakpoint: { max: 10000, min: 1024 },
              items: 3,
            },
            tablet: {
              breakpoint: { max: 1024, min: 464 },
              items: 3,
            },
            mobile: {
              breakpoint: { max: 640, min: 0 },
              items: 1,
            },
          };
        }

        renderReact(
          <ProductAndCategorySlider values={values} responsive={responsive} />,
          slider
        );
      }
    });
  }

  if (document.querySelectorAll('.category-slider').length > 0) {
    const ProductAndCategorySlider = DynamicComponent({
      loader: () => import('./Components/ProductAndCategorySlider'),
    });
    Array.from(document.querySelectorAll('.category-slider')).forEach(
      (slider, index) => {
        const values = [...slider.querySelectorAll('.category__block')].map(
          (block) => {
            return {
              image: block.dataset.image,
              url: block.dataset.url,
              text: block.dataset.text,
            };
          }
        );
        if (values.length > 0) {
          let responsive = {};
          if (values.length > 6) {
            responsive = {
              desktop: {
                breakpoint: { max: 10000, min: 1024 },
                items: 6,
              },
              tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3,
              },
              mobile: {
                breakpoint: { max: 640, min: 0 },
                items: 1,
              },
            };
          }
          if (values.length >= 5) {
            responsive = {
              desktop: {
                breakpoint: { max: 10000, min: 1024 },
                items: 5,
              },
              tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3,
              },
              mobile: {
                breakpoint: { max: 640, min: 0 },
                items: 1,
              },
            };
          } else {
            responsive = {
              desktop: {
                breakpoint: { max: 10000, min: 1024 },
                items: 3,
              },
              tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3,
              },
              mobile: {
                breakpoint: { max: 640, min: 0 },
                items: 1,
              },
            };
          }
          renderReact(
            <ProductAndCategorySlider
              values={values}
              responsive={responsive}
            />,
            slider
          );
        }
      }
    );
  }

  if (document.querySelectorAll('.product-focus-slider').length > 0) {
    const ProductAndCategorySlider = DynamicComponent({
      loader: () => import('./Components/ProductAndCategorySlider'),
    });
    Array.from(document.querySelectorAll('.product-focus-slider')).forEach(
      (slider, index) => {
        const values = [
          ...slider.querySelectorAll('.product-focus__block'),
        ].map((block) => {
          return {
            image: block.dataset.image,
            url: block.dataset.url,
            text: block.dataset.text,
          };
        });
        if (values.length > 0) {
          const responsive = {
            mobile: {
              breakpoint: { max: 10000, min: 0 },
              items: 1,
            },
          };
          renderReact(
            <ProductAndCategorySlider
              values={values}
              responsive={responsive}
            />,
            slider
          );
        }
      }
    );
  }

  if (document.querySelectorAll('.product-image-slider-item').length > 0) {
    const ProductImageSlider = DynamicComponent({
      loader: () => import('./Components/ProductImageSlider'),
    });
    const sliderItems = document.querySelectorAll('.product-image-slider-item');

    const values = [];

    sliderItems.forEach((element, indexNr) => {
      if (element.dataset.src) {
        values.push({
          image: { src: element.dataset.src, index: element.dataset.index, alt: element.dataset.alt },
        });
      }
      if (element.dataset.content) {
        const videoUrl = element.dataset.content.trim();
        const isYoutubeVideo = true;
        values.push({
          video: { videoUrl, isYoutubeVideo, index: element.dataset.index },
        });
      }

      const elementToUse = document.getElementById(
        'product-image-focus__block'
      );
      if (values.length > 0) {
        const responsive = {
          mobile: {
            breakpoint: { max: 10000, min: 0 },
            items: 1,
          },
        };

        renderReact(
          <ProductImageSlider
            values={values}
            responsive={responsive}
            selectedIndex={indexNr}
          />,
          elementToUse
        );
      }
    });
  }

  if (document.querySelectorAll('buy-button').length > 0) {
    const BuyButton = DynamicComponent({
      loader: () => import('./Components/BuyButton'),
    });
    Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
      const {
        articleNumber,
        quantityFieldId,
        href,
        cssClass,
        label,
      } = button.dataset;
      renderReact(
        <Provider store={store}>
          <BuyButton
            {...{
              label,
              articleNumber,
              quantityFieldId,
              href,
              cssClass,
            }}
          />
        </Provider>,
        button
      );
    });
  }

  if (document.getElementById('orderHistoryPage')) {
    const el = document.getElementById('orderHistoryPage'); 
    const OrderList = DynamicComponent({
      loader: () => import('./Components/OrderHistoryListContainer'),
    });
    renderReact(
      <Provider store={store}>
        <OrderList canResendOrders={el.dataset.canresendorders == "True"}/>
      </Provider>,
      document.getElementById('orderHistoryPage')
    );
  }


  if (document.querySelectorAll('.inventory-edit').length > 0) {
      Array.from(document.querySelectorAll('.inventory-edit')).forEach(
          (element) => {
              renderReact(
                  <Provider store={store}>
                      <InventoryEditContainer />
                  </Provider>,
                  element
              );
          }
      );
  }


  if (document.querySelectorAll('countries-list').length > 0) {
    const CountriesList = DynamicComponent({
      loader: () => import('./Components/CountriesList'),
    });
    Array.from(document.querySelectorAll('countries-list')).forEach((data) => {
      let countries = data.dataset.countries;
      ReactDOM.render(
        <Provider store={store}>
          <CountriesList />
        </Provider>,
        data
      );
    });
  }

  if (document.querySelectorAll('top-links').length > 0) {
    const TopLink = DynamicComponent({
      loader: () => import('./Components/TopLink'),
    });
    Array.from(document.querySelectorAll('top-links')).forEach((data) => {
      ReactDOM.render(
        <Provider store={store}>
          <TopLink />
        </Provider>,
        data
      );
    });
  }

  if (document.querySelectorAll('header-profile').length > 0) {
    const Profile = DynamicComponent({
      loader: () => import('./Components/Profile'),
    });
    Array.from(document.querySelectorAll('header-profile')).forEach((data) => {
      ReactDOM.render(
        <Provider store={store}>
          <Profile />
        </Provider>,
        data
      );
    });
  }

  if (document.querySelectorAll('login-info').length > 0) {
    const LogOut = DynamicComponent({
      loader: () => import('./Components/LogOut'),
    });
    Array.from(document.querySelectorAll('login-info')).forEach((data) => {
      ReactDOM.render(
        <Provider store={store}>
          <LogOut />
        </Provider>,
        data
      );
    });
  }

  if (document.querySelectorAll('product-detail-price-view').length > 0) {
    const ProductDetailPriceView = DynamicComponent({
      loader: () => import('./Components/ProductsView/ProductDetailPriceView'),
    });
    Array.from(document.querySelectorAll('product-detail-price-view')).forEach(
      (data) => {
        var productData = data.dataset;
        ReactDOM.render(
          <Provider store={store}>
            <ProductDetailPriceView
              product={productData.product}
              authenticated={
                productData.isauthenticated?.toLowerCase() === 'true'
              }
            />
          </Provider>,
          data
        );
      }
    );
  }
};

const loadComponentIntoElement = (id, Component) => {
  const element = document.getElementById(id);
  if (element) {
    renderReact(
      <Provider store={store}>
        <Component {...element.dataset} />
      </Provider>,
      element
    );
  }
};

bootstrapComponents();
